class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton = this.querySelector('button[type="button"]');
    this.closeButton?.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const clickedOutsideModal = !this.contains(event.target) || event.target.classList.contains('modal-overlay');
    const clickedOutsideSearchForm =
      event.target.closest('.search-modal__content--predictive') && !event.target.closest('.search-modal__form');

    if (clickedOutsideModal || clickedOutsideSearchForm) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    const isHeaderSearchModal = this.id === 'HeaderSearchModal';
    const isMobileViewport = window.matchMedia('(max-width: 989px)').matches;

    trapFocus(focusContainer, isHeaderSearchModal && isMobileViewport ? focusContainer : focusInput);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
